import { gql } from '@apollo/client';
import { rateUnitFragment } from 'helper/fragment';

export const UPDATE_BID_STATUS_MUTATION = gql`
  mutation updateBidStatus(
    $id: [ID]
    $bidStatus: BidStatus
    $isApproved: Boolean
  ) {
    updateBidStatus(id: $id, bidStatus: $bidStatus, isApproved: $isApproved) {
      data
    }
  }
`;

export const BIDS_QUERY = gql`
  ${rateUnitFragment}
  query bids(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    bids(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      totalPages
      totalCount
      bids {
        id
        bidType
        bidderRole
        updatedAt
        bidStartTime
        bidExpireTime
        childBids {
          bidder {
            firstName
          }
          price
          quantity
          quantityUnit
          rateUnit {
            ...rateUnitInfo
          }
          bidType
        }
        bidder {
          id
          firstName
          entityName
          tradeName
          status
          addresses {
            id
            houseNumber
            city {
              cityName
            }
            state {
              stateName
            }
          }
        }
        offer {
          id
          offerType
        }
        demand {
          id
        }
        grade {
          id
          name
        }
      }
    }
  }
`;
